
import { Component, Vue, Prop } from 'vue-property-decorator'
import { clientsModule } from '@/store/modules/store-accessor'
import { TimeUtil } from '@/helpers/TimeUtil'
import { formatAmount } from '@/helpers/data'
import { openInstallationSideview } from '@/helpers/installationSideview'

@Component
export default class ClientsSideviewPaymentsTab extends Vue {
  @Prop() client: Record<string, any>;

  isOpeningJob = false;

  tableheaders: any[] = [
    { class: 'font-weight-black', text: this.$t('date'), sortable: true, value: 'created_at' },
    { class: 'font-weight-black', text: this.$t('amount'), sortable: true, value: 'amount' },
    { class: 'font-weight-black', text: this.$t('payment_type'), sortable: false, value: 'payment_type_id' },
    { class: 'font-weight-black', text: this.$t('receivedBy'), sortable: true, value: 'assignee_id' },
    { class: '', text: '', sortable: false, value: 'open', width: '10px' },
  ]

  formatDate (date: Date): string {
    return TimeUtil.formatDateTime(date)
  }

  formatBalance(balance: number) {
    return formatAmount(balance);
  }

  get clientPayments() {
    return this.client.payments || [];
  }

  async openJob(payment: Record<string, any>) {
    if (!payment.job_id || !payment.installation_id || this.isOpeningJob) return;
    this.isOpeningJob = true;
    try {
      clientsModule.unsetCurrentClient();
      await openInstallationSideview({
        installationId: payment.installation_id,
        tab: 'jobs',
        jobId: payment.job_id,
      });
    } finally {
      this.isOpeningJob = false;
    }
  }
};
